import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DynamoPage } from '../models/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  dynamoPages: DynamoPage[] = [];

  public currentGazemapsPaginationSubject: BehaviorSubject<DynamoPage[]> = new BehaviorSubject(this.dynamoPages);
  public currentPagination!: Observable<DynamoPage[]>;

  dynamoFitPages: DynamoPage[] = [];

  public currentFitPaginationSubject: BehaviorSubject<DynamoPage[]> = new BehaviorSubject(this.dynamoFitPages);
  public currentFitPagination!: Observable<DynamoPage[]>;

  constructor() { }

  public get currentGazemapsPaginationValue(): DynamoPage[] {
    return this.currentGazemapsPaginationSubject.value;
  }

  public setCurrentGazeMapsDynamoPage(_page: DynamoPage) {
    let matchPage = this.currentGazemapsPaginationValue.find((page: DynamoPage) => page.page === _page.page);
    matchPage
      ? matchPage = _page
      : this.currentGazemapsPaginationSubject.value.push(_page);
    this.currentGazemapsPaginationSubject.next(this.currentGazemapsPaginationSubject.value);
  }

  public resetGazeMapPagination(){
    this.dynamoPages = [];
    this.currentGazemapsPaginationSubject = new BehaviorSubject(this.dynamoPages);
    this.currentGazemapsPaginationSubject.next(this.currentGazemapsPaginationSubject.value);
  }

  public get currentFitPaginationValue(): DynamoPage[] {
    return this.currentFitPaginationSubject.value;
  }


  public setCurrentFitDynamoPage(_page: DynamoPage) {
    let matchPage = this.currentFitPaginationValue.find((page: DynamoPage) => page.page === _page.page);
    matchPage
      ? matchPage = _page
      : this.currentFitPaginationSubject.value.push(_page);
    this.currentFitPaginationSubject.next(this.currentFitPaginationSubject.value);
  }

  public resetFitPagination(){
    this.dynamoPages = [];
    this.currentFitPaginationSubject = new BehaviorSubject(this.dynamoPages);
    this.currentFitPaginationSubject.next(this.currentFitPaginationSubject.value);
  }
}
